import { Combobox, FormField, Label } from '@zillow/constellation-10';

import type { ModelDictionaryItemDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

type Option = {
  value: string;
  label: string;
};
type Props = {
  value: Array<string>;
  onChange: (value: Array<string>) => void;
  dictionaryItems: Record<string, ModelDictionaryItemDto> | null;
  disabled?: boolean;
  fieldLabel: string;
  required?: boolean;
};

const FeeComboboxField = ({
  value = [],
  onChange,
  dictionaryItems,
  disabled = false,
  fieldLabel,
  required = false,
}: Props) => {
  const dropdownOptions = [] as Array<Option>;
  if (dictionaryItems) {
    Object.keys(dictionaryItems).forEach((key) => {
      const { feedModelName } = dictionaryItems[key];
      dropdownOptions.push({
        value: key,
        label: feedModelName,
      });
    });
  }

  return (
    <FormField required={required} label={<Label>{fieldLabel}</Label>}>
      <Combobox
        value={value}
        defaultValue={[]}
        disabled={disabled}
        placeholder="Select"
        options={dropdownOptions}
        showLabelForValue={true}
        onChange={(newValue: Array<string>) => onChange(newValue)}
      />
    </FormField>
  );
};

export default FeeComboboxField;
